import { C } from '../../../lib/theme';
import { styles } from '../../../lib/styles';
import { fmtDateTime } from '../../../lib/util';
import type { Case } from '../../../domain/initial-cases';
import { getCurrentUser } from '../../../auth/useUser';
import { useUIState } from '../../../state/contexts/UIStateContext';
import { useLifecycleActions } from '../../../state/actions/lifecycle';

export function ChangesTab({ c }: { c: Case }) {
  const { setModal } = useUIState();
  const { approveChange } = useLifecycleActions();
  const user = getCurrentUser()!;
  const canApprove = user.canApprove;

  // `(x || [])` is unsafe here because the schema default is `'{}'::jsonb`
  // (truthy empty object) — `{}.filter` would crash. See migration 0002 for
  // the schema fix; this guard handles rows backfilled before/after.
  const pendingChanges: any[] = Array.isArray(c.pendingChanges) ? c.pendingChanges : [];
  const changeHistory: any[] = Array.isArray(c.changeHistory) ? c.changeHistory : [];
  const pending = pendingChanges.filter((ch: any) => ch.status === 'PENDING');

  return (
    <div style={styles.card}>
      <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 16 }}>Registrant Data Changes</h3>
      <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 12 }}>Changes to caller info or TNs must be reviewed/approved and synced to Settlement Platform within 24 hours</div>
      {c.status === 'SUCCESSFUL' && <button style={{ ...styles.btn, ...styles.btnGold, ...styles.btnSmall, marginBottom: 16 }} onClick={() => setModal('submit-change')}>+ Submit Change</button>}
      {pending.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <h4 style={{ fontSize: 12, fontWeight: 600, color: C.warn, marginBottom: 8 }}>Pending</h4>
          {pending.map((ch: any) => (
            <div key={ch.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: `1px solid ${C.border}` }}>
              <div><span style={{ ...styles.tag, background: C.infoBg, color: C.info }}>{ch.type}</span> {ch.details}</div>
              {canApprove && <button style={{ ...styles.btn, ...styles.btnGold, ...styles.btnSmall }} onClick={() => approveChange(c.id, ch.id)}>Approve</button>}
            </div>
          ))}
        </div>
      )}
      {changeHistory.length > 0 && (
        <div>
          <h4 style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>History</h4>
          {changeHistory.map((ch: any) => (
            <div key={ch.id} style={{ padding: '8px 0', borderBottom: `1px solid ${C.border}`, fontSize: 12 }}>
              <span style={{ ...styles.tag, background: C.successBg, color: C.success }}>{ch.type}</span> {ch.details}
              <div style={{ color: C.textDim, marginTop: 2 }}>Approved: {fmtDateTime(ch.approvedAt)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
